import { factory, Box, Grid, GridColumn, Flex, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState, useEffect, Fragment } from 'react';
import { OverlayMenuCategory } from '../OverlayMenuCategory/OverlayMenuCategory.mjs';
import { OverlayMenuImage } from '../OverlayMenuImage/OverlayMenuImage.mjs';
import { OverlayMenuItem } from '../OverlayMenuItem/OverlayMenuItem.mjs';
import { OverlayMenuLinks } from '../OverlayMenuLinks/OverlayMenuLinks.mjs';
import { OverlayMenuTabs } from '../OverlayMenuTabs/OverlayMenuTabs.mjs';
import classes from './OverlayMenu.module.css.mjs';
import { countCTAListsWithItems, isILink } from './OverlayMenu.utils.mjs';
import { UtilityBarMobile } from './subcomponent/UtilityBarMobile/UtilityBarMobile.mjs';

const OverlayMenu = factory((props, ref) => {
  const { className, CTALists, images, mainMenuItems, setIsOpenMobileMenu, isMoreOverlay, utilityLinks, buttonCTA, closeCTA, ...rest } = props;
  const [selectedMobileMenuItem, setSelectedMobileMenuItem] = useState(null);
  const [selectedMoreTab, setSelectedMoreTab] = useState(isMoreOverlay && mainMenuItems ? mainMenuItems[0] : null);
  const CTAListsMobile = mainMenuItems?.find((val) => val.text === selectedMobileMenuItem);
  const [openCategoryIndex, setOpenCategoryIndex] = useState(null);
  useEffect(() => {
    if (isMoreOverlay) {
      setSelectedMoreTab(mainMenuItems ? mainMenuItems[0] : null);
    }
  }, [mainMenuItems?.length]);
  return /* @__PURE__ */ React.createElement(Box, { ref, className: clsx(className, "kohler-overlay-menu-root", classes.overlayMenu), ...rest }, /* @__PURE__ */ React.createElement(Grid, { className: classes.overlayMenuLinkGridMainMobileWrapper }, /* @__PURE__ */ React.createElement(GridColumn, { className: classes.overlayMenuLinkGridWrapper }, (CTALists || isMoreOverlay && mainMenuItems) && /* @__PURE__ */ React.createElement(Flex, { className: classes.overlayMenuLinkGridLists }, isMoreOverlay && /* @__PURE__ */ React.createElement(
    OverlayMenuTabs,
    {
      className: classes.overlayMenuLinkGrid,
      CTAs: mainMenuItems?.map((mainMenuItem) => ({
        text: mainMenuItem.text,
        href: mainMenuItem.href,
        onClick: () => setSelectedMoreTab(mainMenuItem),
        isSelected: selectedMoreTab?.text === mainMenuItem.text,
        hasChildrenList: !!mainMenuItem.CTALists
      }))
    }
  ), (selectedMoreTab?.CTALists || CTALists)?.map((CTAList, index) => {
    if (Array.isArray(CTAList)) {
      const overlayMenuLinkGroups = CTAList;
      return /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: "40px", key: `select-more-tab-cta-index-${index}` }, overlayMenuLinkGroups.map((overlayMenuLinkGroup, index2) => /* @__PURE__ */ React.createElement(
        OverlayMenuLinks,
        {
          key: overlayMenuLinkGroup?.title?.text + `overlay-menu-${index2}`,
          className: classes.overlayMenuLinkGrid,
          ...overlayMenuLinkGroup
        }
      )));
    } else {
      const overlayMenuLinkGroup = CTAList;
      return /* @__PURE__ */ React.createElement(Fragment, { key: overlayMenuLinkGroup?.title?.text + `overlay-menu-${index}` }, isMoreOverlay && index % 3 === 0 && index !== 0 && /* @__PURE__ */ React.createElement(Box, { className: classes.overlayMenuLinkGrid }), /* @__PURE__ */ React.createElement(OverlayMenuLinks, { className: classes.overlayMenuLinkGrid, ...overlayMenuLinkGroup }));
    }
  })), (selectedMoreTab?.images || images) && /* @__PURE__ */ React.createElement(Flex, { gap: 30 }, (selectedMoreTab?.images || images)?.map((image) => /* @__PURE__ */ React.createElement(
    OverlayMenuImage,
    {
      key: image.image.src,
      imagesLength: (selectedMoreTab?.images || images)?.length,
      isBusinessTab: !["Bathroom", "Collection", "Kitchen", "Lighting", "Wellness"].includes(rest?.text || ""),
      ...image
    }
  )))), /* @__PURE__ */ React.createElement(GridColumn, { className: classes.overlayMenuLinkGridMobileWrapper }, mainMenuItems && !selectedMobileMenuItem && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      ...closeCTA,
      onClick: (e) => {
        setIsOpenMobileMenu?.(false);
        if (closeCTA && closeCTA.onClick) {
          closeCTA.onClick(e);
        }
      },
      className: clsx(classes.overlayMenuLinkCloseButtonMobile, closeCTA?.className)
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { size: "medium", withBoundingBox: false })
  ), /* @__PURE__ */ React.createElement(Flex, { className: classes.overlayMenuLinkGridListsMobile }, mainMenuItems.map((mainMenuItem, index) => /* @__PURE__ */ React.createElement(Fragment, { key: `${mainMenuItem.text}-mobile-${index}` }, /* @__PURE__ */ React.createElement(
    OverlayMenuItem,
    {
      title: mainMenuItem.text,
      component: mainMenuItem.CTALists ? "button" : "a",
      href: mainMenuItem.CTALists ? void 0 : mainMenuItem.href,
      onClick: mainMenuItem.CTALists ? (e) => {
        setSelectedMobileMenuItem(mainMenuItem.text);
        const CTAListsMobileMap = mainMenuItems?.find((val) => val.text === mainMenuItem.text);
        setOpenCategoryIndex(CTAListsMobileMap && countCTAListsWithItems(CTAListsMobileMap) === 1 ? 0 : null);
        mainMenuItem.onClick?.(e);
      } : void 0,
      className: mainMenuItem.className
    }
  ))), buttonCTA && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Typography,
    {
      type: buttonCTA.onClick ? "button" : void 0,
      component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
      size: "navigation-l",
      textColor: "var(--content-primary)",
      ...omitText(buttonCTA)
    },
    buttonCTA.text
  )))), CTAListsMobile && selectedMobileMenuItem && /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 30 }, /* @__PURE__ */ React.createElement(Flex, { className: classes.overlayMenuLinkLevelOneMobile }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      onClick: () => {
        if (selectedMobileMenuItem) {
          setSelectedMobileMenuItem(null);
        }
      },
      className: closeCTA?.className
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { size: "small", withBoundingBox: true, className: classes.arrowLeftIcon })
  ), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-item-s", textColor: "var(--content-primary)", width: "100%" }, selectedMobileMenuItem), /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      ...closeCTA,
      onClick: () => {
        setIsOpenMobileMenu?.(false);
      },
      className: clsx(classes.overlayMenuLinkCloseButtonMobile, closeCTA?.className)
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { size: "medium", withBoundingBox: false })
  )), /* @__PURE__ */ React.createElement(Flex, { direction: "column" }, CTAListsMobile.CTALists?.map((CTAList, index) => {
    if (Array.isArray(CTAList)) {
      return /* @__PURE__ */ React.createElement(Flex, { direction: "column", key: `cta-list-array-${index}` }, CTAList.map((CTAs, subIndex) => {
        const flatIndex = index * 100 + subIndex;
        const hasItems = CTAs.items?.filter(isILink);
        return /* @__PURE__ */ React.createElement(Fragment, { key: CTAs?.title?.text + `overlay-category-${CTAs.title}-${subIndex}` }, CTAs.title && /* @__PURE__ */ React.createElement(
          OverlayMenuCategory,
          {
            title: CTAs.title,
            isCTA: CTAs.isCTA,
            links: hasItems || [],
            opened: hasItems ? openCategoryIndex === flatIndex : void 0,
            onToggle: hasItems ? () => setOpenCategoryIndex(openCategoryIndex === flatIndex ? null : flatIndex) : void 0,
            className: CTAs.className
          }
        ));
      }));
    }
    return /* @__PURE__ */ React.createElement(Fragment, { key: CTAList?.title?.text || `overlay-category-${CTAList.title}` }, CTAList.title ? /* @__PURE__ */ React.createElement(
      OverlayMenuCategory,
      {
        title: CTAList.title,
        isCTA: CTAList.isCTA,
        links: CTAList.items?.filter(isILink) || [],
        opened: CTAList.items?.filter(isILink) && openCategoryIndex === index,
        onToggle: CTAList.items?.filter(isILink) ? () => setOpenCategoryIndex(openCategoryIndex === index ? null : index) : void 0
      }
    ) : CTAList.items && CTAList.items.length && CTAList.items.length > 0 && CTAList.items.map((CTAs, index2) => /* @__PURE__ */ React.createElement(Fragment, { key: `${CTAs?.title?.text || "no-title"}-overlay-category-${index2}` }, CTAs.title && /* @__PURE__ */ React.createElement(
      OverlayMenuCategory,
      {
        title: CTAs.title,
        links: CTAs.items?.filter(isILink),
        showArrow: false,
        isExternal: CTAs.newTabGroup || CTAs.title.target === "_blank"
      }
    ))));
  })), CTAListsMobile.images && /* @__PURE__ */ React.createElement(Flex, { className: classes.overlayMenuMobileImages }, CTAListsMobile.images.map((image) => /* @__PURE__ */ React.createElement(
    OverlayMenuImage,
    {
      key: image.image.src,
      imagesLength: CTAListsMobile?.images?.length,
      isBusinessTab: !["Bathroom", "Collection", "Kitchen", "Lighting", "Wellness"].includes(rest?.text || ""),
      ...image
    }
  )))))), mainMenuItems && !selectedMobileMenuItem && /* @__PURE__ */ React.createElement(UtilityBarMobile, { utilityLinks }));
});

export { OverlayMenu };
